<div class="w-full mx-auto p-5">
    <div class="max-w-4xl mx-auto">
        <!-- Header -->
        <div class="mb-6">
            <h1 class="text-2xl font-bold text-gray-800">
                {{ isEditMode ? 'Editar Nota Débito' : 'Nueva Nota Débito' }}
            </h1>
            <p class="text-gray-500 mt-1">Complete los campos para {{ isEditMode ? 'actualizar' : 'crear' }} la nota
                débito</p>
        </div>

        <!-- Form -->
        <form [formGroup]="debitNoteForm" (ngSubmit)="onSubmit()" class="bg-white rounded-xl shadow-md p-6 space-y-6">

            <!-- Banco (Required) -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Banco <span class="text-green-500">*</span>
                </label>
                <p-dropdown formControlName="bankId" [filter]="true" filterBy="label" [showClear]="true"
                    [options]="banks" placeholder="Seleccione un banco" class="w-full custom-dropdown">
                </p-dropdown>
                <p *ngIf="debitNoteForm.get('bankId')?.invalid && debitNoteForm.get('bankId')?.touched"
                    class="text-green-500 text-sm mt-1">
                    El banco es requerido
                </p>
            </div>

            <!-- Número de Documento (Optional) -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Número de Documento
                </label>
                <input type="text" formControlName="documentNumber" maxlength="50"
                    class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-red-500"
                    placeholder="Ej: ND-2024-001">
                <p *ngIf="debitNoteForm.get('documentNumber')?.invalid && debitNoteForm.get('documentNumber')?.touched"
                    class="text-green-500 text-sm mt-1">
                    El número de documento no puede exceder 50 caracteres
                </p>
            </div>

            <!-- Tipo de Nota Débito (Required) -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Tipo de Nota Débito <span class="text-green-500">*</span>
                </label>
                <select formControlName="debitNoteType"
                    class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-500">
                    <option value="1">Cargo adicional</option>
                    <option value="2">Intereses</option>
                    <option value="3">Multa</option>
                    <option value="4">Corrección</option>
                    <option value="5">Otro</option>
                    <option value="6">Comisiones Bancarias</option>
                </select>
                <p *ngIf="debitNoteForm.get('debitNoteType')?.invalid && debitNoteForm.get('debitNoteType')?.touched"
                    class="text-green-500 text-sm mt-1">
                    El tipo de nota débito es requerido
                </p>
            </div>

            <!-- Fecha del Documento (Required) -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Fecha del Documento <span class="text-green-500">*</span>
                </label>
                <p-calendar formControlName="documentDate" dateFormat="dd/mm/yy" [showIcon]="true"
                    [iconDisplay]="'input'" placeholder="Selecciona la fecha" styleClass="w-full"
                    inputStyleClass="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-500"
                    [appendTo]="'body'">
                </p-calendar>
                <p *ngIf="debitNoteForm.get('documentDate')?.invalid && debitNoteForm.get('documentDate')?.touched"
                    class="text-green-500 text-sm mt-1">
                    La fecha es requerida
                </p>
            </div>

            <!-- Monto (Required) -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Monto <span class="text-green-500">*</span>
                </label>
                <div class="relative">
                    <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                        <span class="text-gray-500">$</span>
                    </div>
                    <input type="text" appCurrencyFormatter formControlName="amount"
                        class="w-full pl-8 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-500"
                        placeholder="0">
                </div>
                <p *ngIf="debitNoteForm.get('amount')?.invalid && debitNoteForm.get('amount')?.touched"
                    class="text-green-500 text-sm mt-1">
                    El monto es requerido y debe ser mayor a 0
                </p>
            </div>

            <!-- Concepto (Required) -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Concepto <span class="text-green-500">*</span>
                </label>
                <input type="text" formControlName="concept" maxlength="500"
                    class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-500"
                    placeholder="Descripción del concepto">
                <p *ngIf="debitNoteForm.get('concept')?.invalid && debitNoteForm.get('concept')?.touched"
                    class="text-green-500 text-sm mt-1">
                    El concepto es requerido
                </p>
            </div>

            <!-- Observaciones (Optional) -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Observaciones
                </label>
                <textarea formControlName="observations" rows="3" maxlength="1000"
                    class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-500"
                    placeholder="Observaciones adicionales (opcional)"></textarea>
            </div>

            <!-- Proyecto (Optional) -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Proyecto (Opcional)
                </label>
                <p-dropdown formControlName="projectId" [filter]="true" filterBy="label" [showClear]="true"
                    [options]="projects" placeholder="Sin proyecto" (onFilter)="onSearchProjects($event)"
                    class="w-full custom-dropdown">
                </p-dropdown>
            </div>

            <!-- Participante (Optional) -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Participante (Opcional)
                </label>
                <p-dropdown formControlName="participantId" [filter]="true" filterBy="label" [showClear]="true"
                    [options]="participants" placeholder="Sin participante" (onFilter)="onSearchParticipants($event)"
                    class="w-full custom-dropdown">
                </p-dropdown>
            </div>

            <!-- Tercero (Optional) -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Tercero (Opcional)
                </label>
                <p-dropdown formControlName="thirdPartiesId" [filter]="true" filterBy="label" [showClear]="true"
                    [options]="thirdParties" placeholder="Sin tercero" (onFilter)="onSearchThirdParties($event)"
                    class="w-full custom-dropdown">
                </p-dropdown>
            </div>

            <!-- Actions -->
            <div class="flex justify-end gap-4 pt-4 border-t">
                <button type="button" (click)="onCancel()"
                    class="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition">
                    Cancelar
                </button>
                <button type="submit" [disabled]="debitNoteForm.invalid"
                    class="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition disabled:opacity-50 disabled:cursor-not-allowed">
                    {{ isEditMode ? 'Actualizar' : 'Crear' }} Nota Débito
                </button>
            </div>
        </form>
    </div>
</div>

<!-- Modal de Confirmación -->
<app-confirmation-modal #confirmationModal [isVisible]="showConfirmationModal" [config]="confirmationConfig"
  (confirmed)="onConfirmationModalConfirmed()" (cancelled)="onConfirmationModalCancelled()"
  (closed)="onConfirmationModalClosed()">
</app-confirmation-modal>